<template>
  <div class="park-box">
    <div class="park-box-t">产业聚集区</div>
    <div class="park-box-b">
      <div class="park-box-li" v-for="item in 4" :key="item">
        <div class="park-box-b-l">
          <img src="../../../assets/images/home/land.png" alt="" />
        </div>
        <div class="park-box-b-r">
          <div class="park-box-b-span1">XXXX产业聚集区</div>
          <div class="park-box-b-span2">科技产业</div>
          <div class="park-box-b-span3">
            <div>昆明市五华区</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getParkList } from "@/api/setting/investment";
export default {
  props: {
    county: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      list: [],
    };
  },
  watch: {
    county(val) {
      this.getList();
    },
  },
  mounted() {
    //this.getList();
  },
  methods: {
    getList() {
      getParkList({ county: this.county }).then((res) => {
        if (res.data.success) {
          console.log(res.data);
          this.list = res.data.data;
        }
      });
    },
  },
};
</script>
<style scoped>
.park-box {
  width: calc(100% - 20px);
  height: 100%;
  /* box-shadow: 4px 0 10px #dddddd; */
  margin: 0 10px;
  padding: 0 10px;
}
.park-box-t {
  width: 100%;
  /* height: 35px;
  line-height: 35px; */
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #acacac;
  font-size: 0.95rem;
  font-weight: 600;
}

.park-box-b {
  width: 100%;
  height: calc(100% - 46px);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  flex-grow: 1;
}
.park-box-b::-webkit-scrollbar {
  width: 6px;
  height: 4px;
  background-color: #cfe0f5;
  border-radius: 4px;
}
.park-box-b::-webkit-scrollbar-thumb {
  background-color: rgba(113, 155, 199, 0.7);
  /* background-color: rgba(8, 49, 94, 0.7); */
  border-radius: 4px;
}
.park-box-li {
  height: calc((100% - 30px) / 3);
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex: 0 0 auto;
  margin-bottom: 10px;
}
.park-box-b-l {
  width: 120px;
}
.park-box-b-l > img {
  width: 100%;
  height: 100%;
}
.park-box-b-r {
  width: calc(100% - 130px);
  height: 100%;
  display: flex;
  flex-direction: column;
}
.park-box-b-span3 {
  margin-top: 20px;
  width: 100%;
  display: flex;
  font-size: 0.75rem;
  color: #828181;
}

.park-box-b-span2 {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 15px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #0366cb;
}
.park-box-b-span1 {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.85rem;
  color: #000000;
}
</style>